import { cssGenerator } from '@yola/ws-sdk';
import { classTokenFormats } from './class-token-formats';
import { flexDirectionValues, flexWrapValues } from './target-class-values';

const { AUTO_FILL_PREFIX } = cssGenerator.constants;

const targetClasses = {
  COL: 'col',
  COL_PADDING_LEFT: 'col-pl',
  COL_PADDING_RIGHT: 'col-pr',
  AUTO_COL_PADDING_LEFT: `${AUTO_FILL_PREFIX}col-pl`,
  AUTO_COL_PADDING_RIGHT: `${AUTO_FILL_PREFIX}col-pr`,
  COLS_GAP_X: 'cols-gap-x',
  BORDER_TOP: 'border-t',
  BORDER_RIGHT: 'border-r',
  BORDER_BOTTOM: 'border-b',
  BORDER_LEFT: 'border-l',
  ROUNDED_TOP_LEFT: 'rounded-tl',
  ROUNDED_TOP_RIGHT: 'rounded-tr',
  ROUNDED_BOTTOM_LEFT: 'rounded-bl',
  ROUNDED_BOTTOM_RIGHT: 'rounded-br',
  PADDING_TOP: 'pt',
  PADDING_BOTTOM: 'pb',
  AUTO_PADDING_TOP: `${AUTO_FILL_PREFIX}pt`,
  AUTO_PADDING_BOTTOM: `${AUTO_FILL_PREFIX}pb`,
  GAP_Y: 'gap-y',
  FLEX_DIRECTION: 'flex-direction',
  FLEX_WRAP: 'flex-wrap',
  GROW: 'grow',
  OUTER_SHADOW: 'outer-shadow',
};

/*
  Supported configuration shapes:
  BRACKETED:
  {
    format: classTokenFormats.BRACKETED,
    tokenName?: string,
  }
  - `format` selects the bracketed token handler
  - `tokenName` sets the CSS class prefix: `<tokenName>-[<value>]` (defaults to the target name)

  ALIASED:
  {
    format: classTokenFormats.ALIASED,
    tokens: { [value]: className },
  }
  - `format` selects the aliased token handler
  - `tokens` maps each target value to a full CSS class name
 */
const targetClassesConfig = {
  [targetClasses.COL]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.COL_PADDING_LEFT]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.COL_PADDING_RIGHT]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.COLS_GAP_X]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.ROUNDED_TOP_LEFT]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.ROUNDED_TOP_RIGHT]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.ROUNDED_BOTTOM_LEFT]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.ROUNDED_BOTTOM_RIGHT]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.PADDING_TOP]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.PADDING_BOTTOM]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.GAP_Y]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.GROW]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.BORDER_TOP]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.BORDER_RIGHT]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.BORDER_BOTTOM]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.BORDER_LEFT]: {
    format: classTokenFormats.BRACKETED,
  },
  [targetClasses.OUTER_SHADOW]: {
    format: classTokenFormats.BRACKETED,
    tokenName: 'shadow',
  },
  [targetClasses.FLEX_DIRECTION]: {
    format: classTokenFormats.ALIASED,
    tokens: {
      [flexDirectionValues.ROW]: 'flex-row',
      [flexDirectionValues.ROW_REVERSE]: 'flex-row-reverse',
    },
  },
  [targetClasses.FLEX_WRAP]: {
    format: classTokenFormats.ALIASED,
    tokens: {
      [flexWrapValues.WRAP]: 'flex-wrap',
      [flexWrapValues.WRAP_REVERSE]: 'flex-wrap-reverse',
    },
  },
};

export { targetClasses, targetClassesConfig };
